import { render, staticRenderFns } from "./modal_registrarEquipo.vue?vue&type=template&id=52c83386&scoped=true&"
import script from "./modal_registrarEquipo.vue?vue&type=script&lang=js&"
export * from "./modal_registrarEquipo.vue?vue&type=script&lang=js&"
import style0 from "./modal_registrarEquipo.vue?vue&type=style&index=0&id=52c83386&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c83386",
  null
  
)

export default component.exports